// Duración por defecto de un proyecto de video, en segundos.
//
// Vive acá y no en cada pantalla porque la usan TRES lugares que tienen que
// coincidir: la creación del proyecto (`VideoProjects`, que escribe la fila),
// el estado inicial del editor y el fallback de carga del editor para
// proyectos viejos guardados sin duración. Si los tres no dicen lo mismo, la
// tarjeta del listado y el transporte del editor muestran números distintos
// para el mismo proyecto recién creado.
//
// Es sólo el punto de partida: apenas hay clips, la duración real la manda el
// contenido (`contentDuration`) y se persiste en cada guardado.
export const DURACION_INICIAL_SEGUNDOS = 15;
